define(
    'app/components/browsercheck',[
        'fixxer!app/helper/browsercheck',
        'toasties'
    ],
    function (
        browsercheck,
        Toasties
    ){

        return function() {
            browsercheck.check({
                alertFn: Toasties.warn
            });
        }


});

